import { useTranslation } from 'react-i18next'
import { VpButton } from '@vtmn-play/react'
import Modal from 'components/common/mygame/modal/modal'

type MissingPreviousYearGmvModalProps = {
  onClose: () => void
}

const MissingPreviousYearGmvModal = ({ onClose }: MissingPreviousYearGmvModalProps) => {
  const { t } = useTranslation()

  return (
    <div className="mg-store-trajectory-edit" data-testid="store-trajectory-edit-missing-previous-year-gmv">
      <Modal
        open
        title={t('general.trajectory.store.edit.missing_n1.title')}
        footer={
          <VpButton
            data-testid="store-trajectory-edit-missing-previous-year-gmv-close"
            variant="primary"
            variantStyle="regular"
            size="medium"
            onClick={onClose}
          >
            {t('close')}
          </VpButton>
        }
      >
        <p className="vp-body-l">{t('general.trajectory.store.edit.missing_n1.message')}</p>
      </Modal>
    </div>
  )
}

export default MissingPreviousYearGmvModal
